<template>
  <div class="filter-multiple">
    <template v-if="existEvents">
      <div class="filter-multiple-section">
        <span class="filter-label">{{ $t('src/components/coursesettingsblock.importance') }}</span>
        <div class="d-flex mt-2 ml-2">
          <div
            v-for="item in importanceEvents"
            :key="item"
            class="border-square"
            :class="{ active: isSelectedSquare(item) }"
          >
            <div class="square" :class="'square-' + item" @click="selectImportance(item)"></div>
          </div>
        </div>
      </div>
      <div class="canvas"></div>
      <div class="filter-multiple-section mb-2 filter-label">
        {{ $t('src/components/coursesettingsblock.cardioEvents') }}
      </div>
    </template>
    <div
      v-for="event in eventsList"
      :key="event.type"
      class="filter-multiple__item filter-multiple__narrow container"
      :class="{ active: isSelected(event.type) }"
      @click="selectEvent(event.type)"
    >
      <div class="row">
        <div class="col-10">
          <span class="dot" :class="event.color ? 'dot-' + event.color : 'dot'">●</span>
          {{ event.text }}
        </div>
        <div class="col" v-if="existEvents">({{ event.count }})</div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventsConfig, notShow } from '@/events.config.js'
import('@/styles/components/filter.less')

export default {
  name: 'CardioEventsFilter',
  model: {
    prop: 'selectedEvents'
  },
  props: {
    selectedEvents: {
      type: Array,
      required: true
    },
    selectedImportance: {
      type: Array,
      required: false
    },
    existEvents: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    isShow: false,
    eventsList: null,
    localSelected: [],
    localImportance: [],
    importanceEvents: ['danger', 'warning', 'secondary', 'primary']
  }),
  computed: {},
  watch: {
    selectedEvents() {
      this.localSelected = this.selectedEvents
    },
    selectedImportance() {
      this.localSelected = this.selectedEvents
      this.addEventsToList()
    },
    existEvents() {
      this.addEventsToList()
    }
  },
  mounted() {
    this.localSelected = this.selectedEvents
    this.localImportance = this.selectedImportance ? this.selectedImportance : this.importanceEvents
    this.addEventsToList()
  },
  methods: {
    selectEvent(type) {
      let pos = this.localSelected.indexOf(type)
      if (pos === -1) {
        this.localSelected.push(type)
      } else {
        this.localSelected.splice(pos, 1)
      }
      this.$emit('set:events', this.localSelected)
    },
    selectImportance(item) {
      let pos = this.localImportance.indexOf(item)
      if (pos === -1) {
        this.localImportance.push(item)
      } else {
        this.localImportance.splice(pos, 1)
      }
      this.$emit('input:importance', this.localImportance)
    },
    isSelected(type) {
      return this.localSelected && this.localSelected.indexOf(type) !== -1
    },
    isSelectedSquare(item) {
      return this.localImportance && this.localImportance.indexOf(item) !== -1
    },
    addEventsToList() {
      if (!this.existEvents) {
        let res = []
        // eslint-disable-next-line no-unused-vars
        for (let key in eventsConfig) {
          if (key !== 'break' && key !== 'reconnected') {
            res.push(eventsConfig[key])
            res[res.length - 1].type = key
          }
        }
        this.eventsList = this.sortArray(res)
      } else {
        let unsorted = this.existEvents.reduce((list, current) => {
          if (!notShow.includes(current.type) && (!current.end || current.begin <= current.end)) {
            let idx = list.findIndex(item => item.abbr === eventsConfig[current.type].abbr)
            if (idx == -1) {
              list.push(eventsConfig[current.type])
              list[list.length - 1].count = 1
              list[list.length - 1].type = current.type
            } else {
              list[idx].count += 1
            }
          }
          return list
        }, [])

        this.eventsList = this.sortArray(unsorted)
      }
    },
    sortArray(array) {
      let danger = [],
        warning = [],
        primary = [],
        secondary = []

      array.forEach(element => {
        if (this.localImportance.indexOf(element.color) !== -1) {
          switch (element.color) {
            case 'warning':
              warning.push(element)
              break
            case 'primary':
              primary.push(element)
              break
            case 'secondary':
              secondary.push(element)
              break
            default:
              danger.push(element)
              break
          }
        }
      }, this)

      let sorted = []
      sorted.push(...danger, ...warning, ...secondary, ...primary)
      return sorted
    }
  }
}
</script>
